module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "bugs-and-suggestions"
    }
  }, [_c('div', {
    staticClass: "button-container"
  }, [(_vm.isLoggedIn && !_vm.showSubmitForm && !_vm.showThankYouForm) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSubmitForm = true
      }
    }
  }, [_vm._v("Submit a Bug or Suggestion")]) : _vm._e()]), _vm._v(" "), (_vm.isLoggedIn && _vm.showSubmitForm && !_vm.showThankYouForm) ? _c('section', {
    attrs: {
      "id": "submit-work-item"
    }
  }, [_c('h2', [_vm._v("Submit a Bug or Suggestion")]), _vm._v(" "), (_vm.submitFormErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.submitFormErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submitTitle),
      expression: "submitTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Title",
      "disable": _vm.submitIsSaving
    },
    domProps: {
      "value": (_vm.submitTitle)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.submitTitle = $event.target.value
      }, function($event) {
        _vm.submitFormErrors = []
      }]
    }
  }), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Description",
      "disable": _vm.submitIsSaving
    },
    model: {
      value: (_vm.submitDescription),
      callback: function($$v) {
        _vm.submitDescription = $$v
      },
      expression: "submitDescription"
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.submitType),
      expression: "submitType"
    }],
    attrs: {
      "disable": _vm.submitIsSaving
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.submitType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "bug"
    }
  }, [_vm._v("Bug")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "suggestion"
    }
  }, [_vm._v("Suggestion")])]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    attrs: {
      "disable": _vm.submitIsSaving
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSubmitForm = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disable": _vm.submitIsSaving
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitWorkItem($event)
      }
    }
  }, [_vm._v("Submit")])], 1) : _vm._e(), _vm._v(" "), (_vm.showThankYouForm) ? _c('section', {
    attrs: {
      "id": "submit-thank-you"
    }
  }, [_c('h1', [_vm._v("Thank you for your Submission!")]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSubmitForm = false;
        _vm.showThankYouForm = false;
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSubmitForm = true;
        _vm.showThankYouForm = false
      }
    }
  }, [_vm._v("Submit Another")])])]) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "task-board"
    }
  }, [_c('section', {
    attrs: {
      "id": "bugs"
    }
  }, [_c('h1', [_vm._v("Bugs")]), _vm._v(" "), _vm._l((_vm.bugs), function(item) {
    return _c('div', [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('markdown-content', {
      staticClass: "description",
      attrs: {
        "content": item.description
      }
    }), _vm._v(" "), _c('span', [_vm._v("Submitted By: "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (item.poster.stringUrl))
      }
    }, [_vm._v(_vm._s(item.poster.alias))])], 1), _vm._v(" "), (_vm.isModerator) ? [_c('span', {
      staticClass: "mod-controls"
    }, [_vm._v("\n                        Move to:\n                        "), _c('span', {
      on: {
        "click": function($event) {
          _vm.moveTo(item, 'inProgress')
        }
      }
    }, [_vm._v("In-Progress")])])] : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('section', {
    attrs: {
      "id": "suggestions"
    }
  }, [_c('h1', [_vm._v("Suggestions")]), _vm._v(" "), _vm._l((_vm.suggestions), function(item) {
    return _c('div', [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('markdown-content', {
      staticClass: "description",
      attrs: {
        "content": item.description
      }
    }), _vm._v(" "), _c('span', [_vm._v("Submitted By: "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (item.poster.stringUrl))
      }
    }, [_vm._v(_vm._s(item.poster.alias))])], 1), _vm._v(" "), (_vm.isModerator) ? [_c('span', {
      staticClass: "mod-controls"
    }, [_vm._v("\n                        Move to:\n                        "), _c('span', {
      on: {
        "click": function($event) {
          _vm.moveTo(item, 'inProgress')
        }
      }
    }, [_vm._v("In-Progress")])])] : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('section', {
    attrs: {
      "id": "in-progress"
    }
  }, [_c('h1', [_vm._v("In-Progress")]), _vm._v(" "), _vm._l((_vm.inProgress), function(item) {
    return _c('div', [_c('h3', [_vm._v("[" + _vm._s(item.type) + "] " + _vm._s(item.title))]), _vm._v(" "), _c('markdown-content', {
      staticClass: "description",
      attrs: {
        "content": item.description
      }
    }), _vm._v(" "), _c('span', [_vm._v("Submitted By: "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (item.poster.stringUrl))
      }
    }, [_vm._v(_vm._s(item.poster.alias))])], 1), _vm._v(" "), (_vm.isModerator) ? [_c('span', {
      staticClass: "mod-controls"
    }, [_vm._v("\n                        Move to:\n                        "), _c('span', {
      on: {
        "click": function($event) {
          _vm.moveTo(item, 'done')
        }
      }
    }, [_vm._v("Done")]), _vm._v("\n                        |\n                        "), _c('span', {
      on: {
        "click": function($event) {
          _vm.moveTo(item, 'backlog')
        }
      }
    }, [_vm._v("Backlog")])])] : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('section', {
    attrs: {
      "id": "done"
    }
  }, [_c('h1', [_vm._v("Done")]), _vm._v(" "), _vm._l((_vm.done), function(item) {
    return _c('div', [_c('h3', [_vm._v("[" + _vm._s(item.type) + "] " + _vm._s(item.title))]), _vm._v(" "), (item.description) ? _c('div', [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Submitted By: "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (item.poster.stringUrl))
      }
    }, [_vm._v(_vm._s(item.poster.alias))])], 1), _vm._v(" "), (_vm.isModerator) ? [_c('span', {
      staticClass: "mod-controls"
    }, [_vm._v("\n                        Move to:\n                        "), _c('span', {
      on: {
        "click": function($event) {
          _vm.moveTo(item, 'inProgress')
        }
      }
    }, [_vm._v("In-Progress")]), _vm._v("\n                        |\n                        "), _c('span', {
      on: {
        "click": function($event) {
          _vm.moveTo(item, 'backlog')
        }
      }
    }, [_vm._v("Backlog")])])] : _vm._e()], 2)
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ffd0d6a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/BugsAndSuggestions/BugsAndSuggestions.vue
// module id = 927
// module chunks = 2